<template>
  <div class="recharge">
    <mt-loadmore
      :bottom-method="ChangeQueryRecord"
      :autoFill="false"
      ref="loadmore"
    >
      <div class="bg_color">
        <div class="bg_head">
          <div class="head_content">
            <img class="head_img" :src="logoUrl" />
          </div>
        </div>

        <p class="money_num">￥{{ integral }}</p>
      </div>
      <div class="mains" v-if="dataList.length">
        <div class="main_item" v-for="(item, index) in dataList" :key="index">
          <div class="item_left">
            <div class="left_top">{{ item.DSC }}</div>
            <div class="left_bottom">{{ item.DAT }}</div>
          </div>
          <div class="item_right" v-if="item.type == 2">-{{ item.QTY }}分</div>
          <div class="item_right yellow" v-if="item.type == 1">
            +{{ item.QTY }}分
          </div>
        </div>
      </div>
      <div class="none_list" v-if="dataList.length == 0">
        <img class="main_headimg" src="/static/image/chongzhijilu.png" />
        <p class="main_text">还没有积分记录哦！</p>
      </div>
      <div slot="bottom" class="mint-loadmore-bottom">
        <span v-show="load">松手释放↑</span>

        <!-- <span v-show="scrollFalse">没有更多数据啦！</span> -->
      </div>
    </mt-loadmore>
  </div>
</template>
<script>
export default {
  name: 'Detail',
  data() {
    return {
      // dateVal:'全部'
      moneys: 0,
      dataList: [],
      logoUrl: '/static/image/jifenjilu.png',
      integral: 0,
      vipno: localStorage.getItem('VIPNO'),
      load: false,
      page: 1,
      scrollFalse: true,
    }
  },
  mounted() {
    this.getIntegral()
    this.ChangeQueryRecord(this.page)
  },
  methods: {
    // scrollEvent() {
    //   if (this.scrollFalse) {
    //     if (
    //       this.$refs.app.offsetHeight +
    //         this.$refs.app.scrollTop -
    //         this.$refs.app.scrollHeight ==
    //       0
    //     ) {
    //       this.page += 1
    //       this.ChangeQueryRecord(this.page)
    //     }
    //   }
    // },
    ChangeQueryRecord() {
      if (!this.scrollFalse) {
        return
      }
      this.load = true
      this.scrollFalse = false
      this.RequestVIP(
        `h5/vip/point/history?vipno=${this.vipno}&type=0&page=${this.page}&size=100`,
        (r) => {
          if (r.data.data.table1 != undefined && r.data.data.table1.length) {
            this.dataList = [...this.dataList, ...r.data.data.table1]

            this.scrollFalse = true
            this.page += 1
          } else {
            this.scrollFalse = false
          }
          this.load = false
          this.$refs.loadmore.onBottomLoaded()
        },
        (err) => {
          this.load = false
          this.scrollFalse = true
        }
      )
    },
    getIntegral() {
      this.RequestVIP(
        `h5/vip/point/info?vipno=${this.vipno}&type=0`,
        (r) => {
          if (!!r.data.data.table1.length) {
            this.integral = r.data.data.table1[0].usintegral
          }
        },
        (err) => console.log(err)
      )
    },
  },
}
</script>
<style scoped>
.recharge {
  font-size: 8px;
  width: 100%;
  height: 92vh;
  overflow-x: hidden;
  overflow-y: scroll;
}
.none_list {
  position: fixed;
  top: 40%;
  left: 37%;
  text-align: center;
}
.main_headimg {
  width: 40px;
  height: 40px;
}
.bg_color {
  width: 250px;
  height: 110px;
  background: linear-gradient(310deg, #ff9c60 0%, #ff5a61 100%);
  opacity: 1;
  text-align: center;
  box-sizing: border-box;
  padding: 20px 0 11px;
}
.bg_head {
  width: 44px;
  margin: 0px auto;
  height: 44px;
  background: rgba(255, 255, 255, 0.38);
  border-radius: 50%;

  text-align: center;
  position: relative;
}
.head_content {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 3px;
  left: 3px;
  background: #ffffff;
  border-radius: 50px;
  border: none;
  opacity: 1;
}
.head_img {
  width: 22px;
  height: 22px;
  /* border-radius: 50px; */
  margin: 9px 0 0;
}
.leave_money {
  /* height: 14px; */
  font-size: 9px;
  padding: 30px 0;
  width: 100%;
  margin-left: 25px;
  font-weight: 400;
  color: #212121;
  opacity: 1;
}
.money_num {
  height: 42px;
  font-size: 17px;
  margin-top: 11px;
  /* width: 100%;
  margin-left: 23px; */
  font-weight: 500;
  line-height: 18px;
  color: #ffffff;
  opacity: 1;
}
.search {
  width: 90%;
  height: 25px;
  margin: 4px auto;
  background: white;
  z-index: 999;
  display: flex;
  line-height: 25px;
  padding: 0px 10px;
  font-size: 9px;
  box-sizing: border-box;
  font-weight: 500;
  justify-content: space-between;
  position: relative;
}
.mains {
  width: 100%;
  background: white;
  padding: 5px;
  overflow: scroll;
  box-sizing: border-box;
}

.main_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  padding: 10px 0;
  border-bottom: solid 1px lightgray;
}
.left_top,
.item_right,
.titles {
  font-weight: 600;
}
.titles {
  pointer-events: none;
  position: absolute;
  right: 8px;
  z-index: 999;
}
.item_right {
  font-size: 10px;
  font-weight: 400;
  color: #f2553d;
}
.left_top {
  font-size: 10px;
  color: #212121;
}
.left_bottom {
  font-size: 8px;
  color: #9e9e9e;
  margin-top: 11px;
}
.yellow {
  color: #ffa516;
}
</style>



// WEBPACK FOOTER //
// src/integralDetail/index.vue